import Link from 'next/link';
import styles from '../styles/Home.module.css';
import { MenuGroup } from '../types';

// Every keyboard, in its groups, as on the homepage. Links open keyboards
// without reloading the page, and fetch them on hover rather than all at once.
const KeyboardList = ({ keyboardGroups }: { keyboardGroups: MenuGroup[] }) => (
  <>
    {keyboardGroups.map(({ heading, links }) => (
      <section key={heading || 'keyboards'}>
        {heading && <h2>{heading}</h2>}
        <ul className={styles.keyboardList}>
          {links.map(({ route, label }) => (
            <li key={route}>
              <Link href={route} prefetch={false}>
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </section>
    ))}
  </>
);

export default KeyboardList;
